import { Tabs, TabsContent } from '@/components/ui/tabs';
import JobTitleManagement from './JobTitleManagement';

export default function SystemSettings() {
  return (
    <div>
      {/* <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">System Settings</h1>
        </div>
      </div> */}
      <Tabs defaultValue="job-titles" className="w-full">
        <TabsContent value="job-titles" className="mt-6">
          <JobTitleManagement />
        </TabsContent>
      </Tabs>
    </div>
  );
}